import { ConfiguredRetryStrategy } from '@smithy/util-retry';
import { delayFactory, RetryAllStrategy } from './retry-all-strategy';
export var RetryStrategy;
(function (RetryStrategy) {
    RetryStrategy[RetryStrategy["DEFAULT"] = 0] = "DEFAULT";
    RetryStrategy[RetryStrategy["ALL"] = 1] = "ALL";
})(RetryStrategy || (RetryStrategy = {}));
export const DEFAULT_RETRY_CONFIG = {
    initialDelay: 1000,
};
const DEFAULT_RETRY_ATTEMPTS = 3;
const TOTAL_ATTEMPTS = DEFAULT_RETRY_ATTEMPTS + 1;
export const createRetryStrategy = (retryStrategy, retryOptions) => {
    switch (retryStrategy) {
        case RetryStrategy.DEFAULT:
            return new ConfiguredRetryStrategy(TOTAL_ATTEMPTS, delayFactory(retryOptions.initialDelay));
        case RetryStrategy.ALL:
            return new RetryAllStrategy(TOTAL_ATTEMPTS, retryOptions.initialDelay);
    }
};
